
import React from "react";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const OrganizationSettingsLoading: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8 animate-fade-in bg-pastel-blue-light dark:bg-[#121624]">
      <h1 className="text-3xl font-bold mb-2 text-gray-800 dark:text-gray-100">Paramètres Du Compte</h1>
      <Skeleton className="h-4 w-64 mb-8" />
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Squelette sidebar */}
        <div className="md:col-span-1">
          <Card className="p-0 overflow-hidden shadow-md border-0 rounded-xl">
            <div className="p-6 bg-white dark:bg-gray-800/80 border-b border-gray-100 dark:border-gray-800/50">
              <div className="flex items-center space-x-4 mb-6">
                <Skeleton className="h-12 w-12 rounded-full" />
                <div>
                  <Skeleton className="h-5 w-36 mb-2" />
                  <Skeleton className="h-4 w-28" />
                </div>
              </div>
            </div>
            
            <div className="py-4">
              {Array(6).fill(0).map((_, i) => (
                <div key={i} className={`px-6 py-3.5 ${i === 0 ? 'bg-purple-50 dark:bg-purple-900/20' : ''}`}>
                  <div className="flex items-center">
                    <Skeleton className="h-5 w-5 mr-3" />
                    <Skeleton className="h-4 w-40" />
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>
        
        {/* Squelette contenu */}
        <div className="md:col-span-2">
          <Card className="p-6 shadow-md border-0 rounded-xl dashboard-card">
            <div className="flex justify-between items-center mb-8">
              <Skeleton className="h-7 w-36" />
              <Skeleton className="h-9 w-28 rounded-md" />
            </div>
            
            <div className="space-y-8">
              {Array(3).fill(0).map((_, i) => (
                <React.Fragment key={i}>
                  <div className="mb-3">
                    <div className="flex items-center mb-3">
                      <Skeleton className="h-6 w-6 mr-3" />
                      <Skeleton className="h-5 w-40" />
                    </div>
                    <Skeleton className="h-5 w-64 ml-9" />
                  </div>
                  {i < 2 && <Skeleton className="h-px w-full my-4" />}
                </React.Fragment>
              ))}
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};
